import { http } from '@frontend/fetch';
import { addLocationHeader } from '../utils/add-location-header';

export type AttachPaymentMethodProps = {
  paymentIntentId: string;
  postalCode: string;
  locationId: string | undefined;
  personId: string | undefined;
};

export type AttachPaymentMethodResponse = void;

export const attachPaymentMethod = async ({
  locationId,
  paymentIntentId,
  postalCode,
  personId,
}: AttachPaymentMethodProps) =>
  await http.post<AttachPaymentMethodResponse>(
    `payments/locations/${locationId}/paymentMethods`,
    {
      data: {
        paymentIntentId,
        postalCode,
        personId,
      },
    },
    addLocationHeader(locationId ?? '', {
      'Content-Type': 'application/json',
    })
  );
